// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3jzk5","footer":"Form_footer__f4cey"};